<template>
    <div class="m-5">
        <div class="flex justify-between mb-5">
            <div>
                <h2 class=" text-primary-500 mb-0">
                    My Assignments
                </h2>
            </div>
            <div>
                <d-input v-model="filter" icon="search" icon-pack="fas" placeholder="Search by assignment or user name..." />
            </div>
        </div>
        <d-tabs v-model="activeTab">
            <d-tab-item label="To Complete">
                <div class="m-5">
                    <div class="flex align-top content-start justify-end">
                        <d-checkbox v-model="showOptional" @click="showOptional != showOptional" class="pr-5">
                            Show Optional
                        </d-checkbox>

                        <d-checkbox v-model="showCompleted" @click="showCompleted != showCompleted">
                            Show Completed
                        </d-checkbox>
                    </div>
                    <div class=" flex flex-wrap">
                        <assignment-card class="w-full md:w-1/2 xl:w-1/3  " :assignment="assignment" v-for="assignment in assignments" :key="assignment.id"></assignment-card>
                    </div>
                </div>
            </d-tab-item>
            <d-tab-item :label="`For Review (${assignedCount} Assigned, ${readyCount} Tasks Ready for Review)`">
                <div class="m-5">
                    <div class="flex align-top content-start justify-end">
                        <d-checkbox v-model="showOptional" @click="showOptional != showOptional" class="pr-5">
                            Show Optional
                        </d-checkbox>

                        <d-checkbox v-model="showCompleted" @click="showCompleted != showCompleted">
                            Show Completed
                        </d-checkbox>
                    </div>
                    <div class="flex flex-wrap py-5">
                        <div v-if="reviewerAssignments.length > 0 && !loadingAssignments" class="flex flex-wrap items-stretch -mx-3 mt-5 w-full">
                            <div class=" flex flex-wrap">
                                <assignment-card class="w-full md:w-1/2 xl:w-1/3 " :assignment="review" v-for="review in reviewerAssignments" :key="review.id"></assignment-card>
                            </div>
                        </div>
                        <div v-else-if="loadingAssignments" key="loading" class="flex justify-center py-10">
                            <d-loader />
                        </div>
                        <!--<div v-else key="empty" class="text-center py-10">
                            <p>There are no assignments that you need to review at this time.</p>
                        </div>-->
                        <div class="flex justify-end w-full px-5">
                            <d-pagination :total="total" :per-page="pagination.pageSize" :current="pagination.page" @change="page => pagination.page = page" />
                        </div>
                    </div>
                </div>
            </d-tab-item>

            <d-tab-item v-if="hasRole('Mentor')" label="My Mentees' Assignments">
                <mentor-mentees-assignments :user="user" :filter="filter" />
            </d-tab-item>

            <d-tab-item v-if="hasRole('Consultant')" label="My Community Members' Assignments">
                <consultant-community-members-assignments :user="user" :filter="filter" />
            </d-tab-item>

            <d-tab-item v-if="hasRole('System Administrator')" label="All Assignments">
                <all-assignments :filter="filter" :search-user-id="searchUserId" />
            </d-tab-item>

            <d-tab-item v-if="hasRole('System Administrator')" label="Past Due Assignments">
                <past-due-assignments :filter="filter" />
            </d-tab-item>
        </d-tabs>
    </div>
</template>
<script>
    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import debounce from 'lodash/debounce';

    import DPagination from '@devsquared/d2kit/src/js/elements/DPagination/DPagination.vue';
    import AssignmentCard from './components/AssignmentCard.vue';


    export default {
        parent: true,
        components: {
            DPagination,
            AssignmentCard
        },
        props: {
            user: {
                type: Object,
                default: () => { },
            },
            isAdmin: {
                type: Boolean,
                default: () => false,
            },
            userName: {
                type: String,
                default: () => '',
            },
            searchUserId: {
                type: String,
                default: () => '',
            },
        },
        data: () => ({
            assignments: [],
            reviewerAssignments: [],
            loadingAssignments: false,
            showCompleted: false,
            showOptional: false,
            activeTab: 0,
            total: 0,
            filter: '',
            readyCount: 0,
            assignedCount: 0,
            pagination: {
                page: 1,
                pageSize: 18,
                sortField: 'updatedAt',
                sortOrder: 'desc',
            },
            paginationToComplete: {
                page: 1,
                pageSize: 72,
                sortField: 'updatedAt',
                sortOrder: 'desc',
            },
        }),

        computed: {
            ...mapGetters('d2Auth', ['hasRole']),
        },
        watch: {
            pagination: {
                handler() {
                    if (this.activeTab === 0) {
                        this.getAssignmentsPaged();
                    }

                    if (this.activeTab === 1) {
                        this.getUserReviewerAssignmentsPaged();
                    }
                },
                deep: true,
            },
            paginationToComplete: {
                handler() {
                    if (this.activeTab === 0) {
                        this.getAssignmentsPaged();
                    }

                    if (this.activeTab === 1) {
                        this.getUserReviewerAssignmentsPaged();
                    }
                },
                deep: true,
            },
            filter() {
                if (this.activeTab === 0) {
                    this.getAssignmentsPaged();
                }

                if (this.activeTab === 1) {
                    this.getUserReviewerAssignmentsPaged();
                }
            },
            showCompleted() {
                if (this.activeTab === 0) {
                    this.getAssignmentsPaged();
                }

                if (this.activeTab === 1) {
                    this.getUserReviewerAssignmentsPaged();
                }
            },
            showOptional() {
                if (this.activeTab === 0) {
                    this.getAssignmentsPaged();
                }

                if (this.activeTab === 1) {
                    this.getUserReviewerAssignmentsPaged();
                }
            },
            activeTab() {
                if (this.activeTab === 0) {
                    this.getAssignmentsPaged();
                }

                if (this.activeTab === 1) {
                    this.getUserReviewerAssignmentsPaged();
                }
            },
        },
        mounted() {
            if (this.userName == '') {
                if (this.hasRole('Consultant') && this.hasRole('Mentor')) {
                    this.activeTab = 3;
                } else if (this.hasRole('Consultant')) {
                    this.activeTab = 2;
                } else if (this.hasRole('System Administrator')) {
                    this.activeTab = 1;
                }
            } else {
                this.filter = this.userName.replace('-', ' ');
                if (this.hasRole('Consultant') && this.hasRole('Mentor')) {
                    this.activeTab = 4;
                } else if (this.hasRole('Mentor') || this.hasRole('Consultant')) {
                    this.activeTab = 3;
                } else if (this.hasRole('System Administrator')) {
                    this.activeTab = 2;
                } else {
                    this.activeTab = 3;
                }
            }

            this.getAssignmentsPaged();
            this.getUserReviewerAssignmentsPaged();
        },

        methods: {
            getUserReviewerAssignmentsPaged: debounce(async function () {
                const {
                    page, sortField, sortOrder, pageSize,
                } = this.pagination;
                const params = [
                    `currentPage=${page}`,
                    `pageSize=${pageSize}`,
                    `reviewerId=${this.user.id}`,
                    `filter=${this.filter}`,
                    `showCompleted=${this.showCompleted}`,
                    `showOptional=${this.showOptional}`,
                    `sortDir=${sortField} ${sortOrder}`,
                ].join('&');
                this.loadingAssignments = true;
                if (this.isAdmin) {
                    // Get All Assignments Reviewable By Administrator
                    const { data } = await axios.get(
                        `/api/admin-reviewer/assignments/paged?${params}`,
                    );

                    this.reviewerAssignments = data.resultItems;
                    this.total = data.totalRecords;

                    this.getAdminAssignedAndReadyAssignmentCounts();
                } else {
                    // Get Non-admin reviewable assignments.
                    const { data } = await axios.get(`/api/user-reviewer/assignments/paged?${params}`);
                    this.reviewerAssignments = data.resultItems;
                    this.total = data.totalRecords;

                    this.getUserAssignedAndReadyAssignmentCounts();
                }

                this.loadingAssignments = false;
            }, 1000),

            async getAdminAssignedAndReadyAssignmentCounts() {
                const {
                    page, sortField, sortOrder, pageSize,
                } = this.pagination;
                const params = [
                    `filter=${this.filter}`,
                    `showCompleted=${this.showCompleted}`,
                    `showOptional=${this.showOptional}`
                ].join('&');
                this.loadingAssignments = true;

                // Get All Assignments Reviewable By Administrator
                const { data } = await axios.get(
                    `/api/admin-reviewer/assignments/counts?${params}`,
                );
                this.readyCount = data.readyAssignmentsCount;
                this.assignedCount = data.assignedAssignmentsCount;

                this.loadingAssignments = false;
            },

            async getUserAssignedAndReadyAssignmentCounts() {
                const {
                    page, sortField, sortOrder, pageSize,
                } = this.pagination;
                const params = [
                    `reviewerId=${this.user.id}`,
                    `filter=${this.filter}`,
                    `showCompleted=${this.showCompleted}`,
                    `showOptional=${this.showOptional}`
                ].join('&');
                this.loadingAssignments = true;

                // Get All Assignments Reviewable By User
                const { data } = await axios.get(
                    `/api/user-reviewer/assignments/counts?${params}`,
                );
                this.readyCount = data.readyAssignmentsCount;
                this.assignedCount = data.assignedAssignmentsCount;

                this.loadingAssignments = false;
            },

            getAssignmentsPaged: debounce(async function () {
                const {
                    page, sortField, sortOrder, pageSize,
                } = this.paginationToComplete;
                const params = [
                    `currentPage=${page}`,
                    `pageSize=${pageSize}`,
                    `userId=${this.user.id}`,
                    `filter=${this.filter}`,
                    `showCompleted=${this.showCompleted}`,
                    `showOptional=${this.showOptional}`,
                    `sortDir=${sortField} ${sortOrder}`,
                ].join('&');
                this.loadingAssignments = true;
                try {
                    const { data } = await axios.get(`/api/user/assignments/paged?${params}`);
                    this.assignments = data.resultItems;
                    this.total = data.totalRecords;
                    this.loadingAssignments = false;
                } catch (error) {
                    this.$toast.open({
                        message: error.message,
                        color: 'red-500',
                        duration: 4000,
                    });
                    this.loadingAssignments = false;
                }
            }, 1000),
        },
    };
</script>